export default __webpack_public_path__ + "static/media/headerimg.d789451f.svg";